<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>مشخصات کاربر </h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.title!==null}">عنوان</span>
						<input class="form-control" type="text" v-model="userModel.title" @input="v$.userModel.title.$touch()" :class="{invalid:v$.userModel.title.$error}">
						<p class="text-danger" v-if="v$.userModel.title.required.$invalid && v$.userModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
					</div>

					<div class="mb-3">
						<v-select v-if="userModel.userId!=0 && OrgJobList!=[]" dir="rtl" label="title" placeholder="پست سازمانی" :filterable="OrgJobList.length>10" :searchable="OrgJobList.length>10" :options="OrgJobList" :reduce="x=>x.orgJobId" v-model="userModel.orgJobId">

						</v-select>
						<p class="text-danger" v-if="v$.userModel.orgJobId.required.$invalid && v$.userModel.orgJobId.$dirty">لطفا پست سازمانی را وارد کنید.</p>
					</div>

					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="accessToRelativeGroup-checkbox" type="checkbox" v-model="userModel.accessToRelativeGroup">
							<label class="custom-control-label" for="accessToRelativeGroup-checkbox"></label>
						</div>

						<span class="mr-5">
							دسترسی به
							<span v-if="isKarnegasht==true">فعالیت های </span>
							<span v-if="isKarnegasht==false">وظایف </span>
							همکاران
						</span>

						<!--<input class="medium-checkbox" id="accessToRelativeGroup-checkbox" type="checkbox" v-model="userModel.accessToRelativeGroup">
						<label for="accessToRelativeGroup-checkbox">دسترسی به وظایف همکاران</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="smS_Notification-checkbox" type="checkbox" v-model="userModel.smS_Notification">
							<label class="custom-control-label" for="smS_Notification-checkbox"></label>
						</div>
						<span class="mr-5">ارسال پیامک اطلاع رسانی</span>

						<!--<input class="medium-checkbox" id="smS_Notification-checkbox" type="checkbox" v-model="userModel.smS_Notification">
						<label for="smS_Notification-checkbox">ارسال پیامک اطلاع رسانی</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3" v-if="isKarnegasht==false">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="sendTaskCloseSms-checkbox" type="checkbox" v-model="userModel.sendTaskCloseSms">
							<label class="custom-control-label" for="sendTaskCloseSms-checkbox"></label>
						</div>
						<span class="mr-5">اعلان اطلاع رسانی درخواست بستن</span>

						<!--<input class="medium-checkbox" id="sendTaskCloseSms-checkbox" type="checkbox" v-model="userModel.sendTaskCloseSms">
						<label for="sendTaskCloseSms-checkbox">اعلان اطلاع رسانی درخواست بستن</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="sendTaskTeamUserSms-checkbox" type="checkbox" v-model="userModel.sendTaskTeamUserSms">
							<label class="custom-control-label" for="sendTaskTeamUserSms-checkbox"></label>
						</div>
						<span class="mr-5">ارسال پیامک سایر اعضاء تیم</span>

						<!--<input class="medium-checkbox" id="sendTaskTeamUserSms-checkbox" type="checkbox" v-model="userModel.sendTaskTeamUserSms">
						<label for="sendTaskTeamUserSms-checkbox">ارسال پیامک سایر اعضاء تیم</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3" v-if="!isMinVersion">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="sendTaskWorkSms-checkbox" type="checkbox" v-model="userModel.sendTaskWorkSms">
							<label class="custom-control-label" for="sendTaskWorkSms-checkbox"></label>
						</div>
						<span class="mr-5">ارسال پیامک ثبت پیگیری</span>

						<!--<input class="medium-checkbox" id="sendTaskWorkSms-checkbox" type="checkbox" v-model="userModel.sendTaskWorkSms">
						<label for="sendTaskWorkSms-checkbox">ارسال پیامک ثبت پیگیری</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3" v-if="isKarnegasht==false">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="workMonthAccess-checkbox" type="checkbox" v-model="userModel.workMonthAccess">
							<label class="custom-control-label" for="workMonthAccess-checkbox"></label>
						</div>
						<span class="mr-5">ثبت کارکرد ماهانه</span>

						<!--<input class="medium-checkbox" id="workMonthAccess-checkbox" type="checkbox" v-model="userModel.workMonthAccess">
						<label for="workMonthAccess-checkbox">ثبت کارکرد ماهانه</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="email_Notification-checkbox" type="checkbox" v-model="userModel.email_Notification">
							<label class="custom-control-label" for="email_Notification-checkbox"></label>
						</div>
						<span class="mr-5">ارسال ایمیل</span>

						<!--<input class="medium-checkbox" id="email_Notification-checkbox" type="checkbox" v-model="userModel.email_Notification">
						<label for="email_Notification-checkbox">ارسال ایمیل</label>-->
					</div>

					<!-- <div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="userDisabled-checkbox" type="checkbox" v-model="userModel.disabled">
							<label class="custom-control-label" for="userDisabled-checkbox"></label>
						</div>
						<span class="mr-5">غیرفعال</span>

						<input class="medium-checkbox" id="userDisabled-checkbox" type="checkbox" v-model="userModel.disabled">
						<label for="userDisabled-checkbox">غیرفعال</label>
					</div> -->

					<button :disabled="Loading" class="btn btn-xxs mt-4 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateLocaluserList">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>
		</div>

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';

	export default {
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				testData: null,
				userModel: {
					userCode: "",
					title: null,
					orgJobTitle: 0,
					orgJobId: 0,
					userId: 0,
					disabled: false,
					adminOrUser: true,
					accessToRelativeGroup: true,
					workMonthAccess: false,
					sendTaskWorkSms: false,
					sendTaskTeamUserSms: false,
					sendTaskCloseSms: false,
					email_Notification: false,
					smS_Notification: false
				},
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			OrgJobList() {
				return this.$store.getters.GetOrgJobList;
			},
		},
		created() {
			this.GetOrgJobList();
			this.GetLocaluserListItem();

		},
		methods: {
			GetOrgJobList() {
				this.$store.dispatch("GetOrgJobListFromServer");
			},
			GetLocaluserListItem() {
				this.$http.get("Task/GetUserItemForAdmin?id=" + this.$route.params.userId)
					.then(data => {
						this.userModel = data.data;
						this.userModel.orgJobId = data.data.orgJobId;
						this.testData = data.data;
					});
			},
			CreateLocaluserList() {
				this.v$.$touch();
				if (!this.v$.$invalid) {
					this.$store.dispatch("UpdateUser", this.userModel);
				}
			},

		},
		validations: {
			userModel: {
				title: {
					required
				},
				orgJobId: {
					required
				},

			}


		},

	};
</script>
